import AddToFavouritesButton from '@gik/ui/gik/AddToFavouritesButton/AddToFavouritesButton';
import React from 'react';
import { SvgIcon } from '@gik/ui';

interface BlogAddToFavouritesButtonProps {
  type: 'articles' | 'products';
  typeId: string;
}

export default function BlogAddToFavouritesButton({ type, typeId }: BlogAddToFavouritesButtonProps) {
  return (
    <AddToFavouritesButton
      type={type}
      itemId={typeId}
      child={(onClick, _isLoading, isFavourited) => (
        <div className="favourite-button-wrapper">
          <div className={`favourite-button ${isFavourited ? 'favourited' : ''}`} onClick={onClick}>
            <SvgIcon name={isFavourited ? 'Heart' : 'HeartOutline'} />
          </div>
          <span className="separator">•</span>
        </div>
      )}
    />
  );
}
